var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"col-md-3"},[_c('inqueryFilter',{on:{"search":_vm.search}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('inqueryTable',{ref:"registerTable"})],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa78ce5","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/apr/inqueryApr/inqueryApr.vue
// module id = null
// module chunks = 